export default __webpack_public_path__ + "static/media/lock.1c72a30b.svg";